import React from 'react'
import { Box, Checkbox, Typography, makeStyles } from '@material-ui/core'
import { CommissionPreview } from '../types'
import { money } from '../utils'

const useStyles = makeStyles(theme => ({
  kpis: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2)
  },
  kpi: {
    border: '1px solid #e2e5e9',
    borderRadius: 6,
    padding: theme.spacing(1.25, 1.5),
    background: '#fff',
    '& $kpiValue': { color: '#20242a' }
  },
  kpiPrimary: { borderColor: '#f2b27f', background: '#fff8f2', '& $kpiValue': { color: '#c95300' } },
  kpiPaid: { borderColor: '#b9ddc3', background: '#f4faf6', '& $kpiValue': { color: '#237a3b' } },
  kpiLabel: { color: '#68707b', fontWeight: 600, textTransform: 'uppercase', fontSize: 11 },
  kpiValue: { fontWeight: 700, marginTop: 3, fontVariantNumeric: 'tabular-nums' },
  '@media (max-width: 600px)': { kpis: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' } }
}))

interface Props {
  admin: boolean
  includeGoal: boolean
  preview: CommissionPreview
  selectedTotal: number
  onIncludeGoalChange: (include: boolean) => void
}

const Kpi: React.FC<{ label: string; value: string; className?: string }> = ({ label, value, className = '' }) => {
  const classes = useStyles()
  return (
    <Box className={`${classes.kpi} ${className}`}>
      <Typography className={classes.kpiLabel} variant="caption">
        {label}
      </Typography>
      <Typography className={classes.kpiValue} variant="h6">
        {value}
      </Typography>
    </Box>
  )
}

const CommissionKpis: React.FC<Props> = ({ admin, includeGoal, preview, selectedTotal, onIncludeGoalChange }) => {
  const classes = useStyles()
  return (
    <Box className={classes.kpis}>
      <Box className={classes.kpi}>
        <Typography className={classes.kpiLabel} variant="caption">
          Bono meta
        </Typography>
        <Typography className={classes.kpiValue} variant="h6">
          {money(preview.goalBonus)}
        </Typography>
        {admin && preview.goalBonusState === 'pending' ? (
          <label>
            <Checkbox checked={includeGoal} onChange={event => onIncludeGoalChange(event.target.checked)} />
            Incluir
          </label>
        ) : null}
      </Box>
      <Kpi label="Causada en cohorte" value={money(preview.totalCommission)} />
      <Kpi label="Pagada" value={money(preview.paidCommission)} className={classes.kpiPaid} />
      <Kpi label="Pendiente" value={money(preview.pendingCommission)} className={classes.kpiPrimary} />
      {admin ? <Kpi label="Seleccionada" value={money(selectedTotal)} className={classes.kpiPrimary} /> : null}
    </Box>
  )
}

export default CommissionKpis
